import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/CheckListItems/selectRow',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async selectRowForBuildingDetails(params)
    {
        try
        {
            const response = await axios.get('/CheckListItems/selectRowForBuildingDetails',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async save(params)
    {
        try
        {
            let response;
            if (typeof params.id !== 'undefined' && params.id != '')
            {
                response = await axios.post('/CheckListItems/updateRow', params);
            }
            else
            {
                response = await axios.post('/CheckListItems/insertRow', params);
            }
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/CheckListItems/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
